import { InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../common/auth';
import { LOGIN, INACTIVE_USER } from '../../config/routes';

type Props = {
  children: JSX.Element;
};

function PrivateRoute({ children }: Props) {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const { isLoading, isActive } = useAuth();

  if (inProgress !== InteractionStatus.None || isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={LOGIN} />;
  }

  if (!isActive) {
    return <Navigate to={INACTIVE_USER} />;
  }

  return children;
}

export default PrivateRoute;
